import { QueryRelation } from '../../models/configuration/QueryRelation';
import { IQueryOptions } from '../../models/commonTypes';
import { utils } from '@kurtosys/ksys-app-template';

export default function convertRelationToQueryOptions(
    queryList: Array<QueryRelation> | Array<IQueryOptions>
): Array<IQueryOptions> {
    if (utils.isArrayLike.isArrayLike(queryList) && queryList.length > 0) {
        const updatedQueryList: Array<IQueryOptions> = [];
        for (const query of queryList) {
            if (
                query &&
                !('queryOptionsType' in query) &&
                'key' in query &&
                'query' in query
            ) {
                const updatedQuery: IQueryOptions = query.query;
                updatedQuery.queryId = query.key;
                updatedQueryList.push(updatedQuery);
            } else if (query && 'queryOptionsType' in query) {
                updatedQueryList.push(query);
            }
        }
        return updatedQueryList;
    }
    return queryList as Array<IQueryOptions>;
}



// WEBPACK FOOTER //
// ./src/utils/query/convertRelationToQueryOptions.ts